import { defineComponent, ref } from 'vue-demi';
import { useToggle, onClickOutside } from '@vueuse/core';
import { s as script$2 } from './OrButton-bc9cc4a5.js';
import { s as script$3 } from './OrIconButton-5ccfcc6f.js';
import { resolveComponent, openBlock, createElementBlock, createVNode, withModifiers, createElementVNode, renderSlot, createBlock, withCtx, Fragment, renderList, createCommentVNode } from 'vue';
import { s as styleInject } from './style-inject.es-4c6f2515.js';
import { s as script$4, O as OrFloatingPlacements } from './OrFloating-00617713.js';

var script$1 = defineComponent({
  name: 'OrOverflowMenuItem',
  components: {
    OrButton: script$2
  },
  props: {
    icon: {
      type: String,
      required: false,
      default: null
    },
    label: {
      type: String,
      required: true
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    closeOnClick: {
      type: Boolean,
      required: false,
      default: false
    },
    handler: {
      type: Function,
      required: true
    }
  },
  emits: ['close'],
  methods: {
    onClick() {
      this.handler();
      if (this.closeOnClick) {
        this.$emit('close');
      }
    }
  }
});

const _hoisted_1$1 = {
  class: "or-overflow-menu-item"
};
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_or_button = resolveComponent("or-button");
  return openBlock(), createElementBlock("div", _hoisted_1$1, [createVNode(_component_or_button, {
    type: "text",
    color: "neutral-4",
    icon: _ctx.icon,
    content: _ctx.label,
    "is-disabled": _ctx.isDisabled,
    onClick: withModifiers(_ctx.onClick, ["prevent"])
  }, null, 8 /* PROPS */, ["icon", "content", "is-disabled", "onClick"])]);
}

var css_248z$1 = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-412ad355 {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-412ad355 {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.or-overflow-menu-item .or-button[data-v-412ad355] {\n  justify-content: start;\n  width: 100%;\n  padding: 8px;\n  color: var(--c-neutral-4);\n  white-space: nowrap;\n}\n@media (hover: hover) and (pointer: fine) {\n.or-overflow-menu-item .or-button[data-v-412ad355]:not(:disabled):not(.or-overflow-menu-item .or-button:not(:disabled).is-loading):not(.or-overflow-menu-item .or-button:not(:disabled).is-disabled):not(.or-overflow-menu-item .or-button:not(:disabled).is-readonly):not(.or-overflow-menu-item .or-button:not(:disabled):disabled):not(.or-overflow-menu-item .or-button:not(:disabled).is-focused):not(.or-overflow-menu-item .or-button:not(:disabled):active):hover {\n    color: var(--c-neutral-6);\n}\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.or-overflow-menu-item .or-button[data-v-412ad355]:not(:disabled):not(.or-overflow-menu-item .or-button:not(:disabled).is-loading):not(.or-overflow-menu-item .or-button:not(:disabled).is-disabled):not(.or-overflow-menu-item .or-button:not(:disabled).is-readonly):not(.or-overflow-menu-item .or-button:not(:disabled):disabled):not(.or-overflow-menu-item .or-button:not(:disabled).is-focused):not(.or-overflow-menu-item .or-button:not(:disabled):active):hover {\n    color: var(--c-neutral-6);\n}\n}";
styleInject(css_248z$1);

script$1.render = render$1;
script$1.__scopeId = "data-v-412ad355";
script$1.__file = "src/components/or-overflow-menu/partials/OrOverflowMenuItem.vue";

var script = defineComponent({
  name: 'OrOverflowMenu',
  components: {
    OrIconButton: script$3,
    OrOverflowMenuItem: script$1,
    OrFloating: script$4
  },
  props: {
    closeOnClickOutside: {
      type: Boolean,
      default: true,
      required: false
    },
    placement: {
      type: String,
      required: false,
      default: () => OrFloatingPlacements.BOTTOM_END
    },
    items: {
      type: Array,
      required: false,
      default: () => []
    },
    isDisabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  emits: ['open', 'close'],
  setup(props, {
    emit
  }) {
    const target = ref();
    const content = ref(null);
    const trigger = ref();
    const [isOpen, toggle] = useToggle();
    const close = () => {
      toggle(false);
      emit('close');
    };
    const open = () => {
      if (props.isDisabled) return;
      toggle(true);
      emit('open');
    };
    onClickOutside(content, evt => {
      if (evt.composedPath().includes(target.value)) return;
      if (isOpen.value && props.closeOnClickOutside) close();
    });
    return {
      isOpen,
      target,
      content,
      open,
      close,
      trigger
    };
  }
});

const _hoisted_1 = {
  ref: "target",
  class: "dropdown-container"
};
const _hoisted_2 = {
  ref: "content",
  class: "content"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_or_icon_button = resolveComponent("or-icon-button");
  const _component_or_overflow_menu_item = resolveComponent("or-overflow-menu-item");
  const _component_or_floating = resolveComponent("or-floating");
  return openBlock(), createElementBlock("div", _hoisted_1, [createElementVNode("div", {
    ref: "trigger",
    class: "trigger",
    onClick: _cache[0] || (_cache[0] = withModifiers($event => _ctx.isOpen ? _ctx.close() : _ctx.open(), ["prevent", "stop"]))
  }, [renderSlot(_ctx.$slots, "trigger", {}, () => [createVNode(_component_or_icon_button, {
    icon: "more_vert",
    class: "more_icon",
    "icon-color": "neutral-6",
    "is-disabled": _ctx.isDisabled
  }, null, 8 /* PROPS */, ["is-disabled"])])], 512 /* NEED_PATCH */), _ctx.isOpen ? (openBlock(), createBlock(_component_or_floating, {
    key: 0,
    trigger: _ctx.trigger,
    placement: _ctx.placement,
    "is-using-shift": "",
    "is-using-flip": ""
  }, {
    default: withCtx(() => [createElementVNode("div", _hoisted_2, [renderSlot(_ctx.$slots, "content", {
      close: _ctx.close
    }, () => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, item => {
      return openBlock(), createBlock(_component_or_overflow_menu_item, {
        key: item.label,
        handler: item.handler,
        label: item.label,
        icon: item.icon,
        "close-on-click": item.closeOnClick || false,
        "is-disabled": item.isDisabled,
        onClose: _ctx.close
      }, null, 8 /* PROPS */, ["handler", "label", "icon", "close-on-click", "is-disabled", "onClose"]);
    }), 128 /* KEYED_FRAGMENT */))])], 512 /* NEED_PATCH */)]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["trigger", "placement"])) : createCommentVNode("v-if", true)], 512 /* NEED_PATCH */);
}

var css_248z = ".dropdown-container[data-v-3d084a5a] {\n  position: relative;\n  width: fit-content;\n  height: fit-content;\n}\n.dropdown-container .trigger[data-v-3d084a5a] {\n  cursor: pointer;\n}\n.content[data-v-3d084a5a] {\n  right: 0;\n  z-index: 1;\n  width: fit-content;\n  height: fit-content;\n  background-color: var(--c-neutral-0);\n  border-radius: 3px;\n  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.08);\n}";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-3d084a5a";
script.__file = "src/components/or-overflow-menu/OrOverflowMenu.vue";

export { script as s };
